import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text, useResponsive } from '@common-fe/common-fe';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';

import { useInvestmentsHoldings } from '../../hooks';
import { useGetInvestorAccountId } from '../hook';

import InvestmentBannerAnimation from './InvestmentBannerAnimation';
import InvestmentBannerTitle from './InvestmentBannerTitle';

interface Props {
  children: React.ReactNode;
  isPerformanceMode?: boolean;
}
const InvestmentsBanner: React.FC<Props> = ({ children, isPerformanceMode }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const accountId = useGetInvestorAccountId();
  const { lastDateUpdate } = useInvestmentsHoldings(accountId);
  const getWrapper = (node: React.ReactNode) => {
    if (isMobile) {
      return node;
    }
    return <div>{node}</div>;
  };
  return (
    <Box
      direction={isMobile ? 'column' : 'row'}
      align="center"
      background="investmentBackground"
      round="moduleRound"
      style={{ position: 'relative' }}
    >
      <InvestmentBannerAnimation />
      <Box
        direction={isMobile ? 'column' : 'row'}
        align="center"
        fill
        style={{ zIndex: 3 }}
        pad={{
          horizontal: isMobile ? 'spacing24' : 'xxxl',
          vertical: isPerformanceMode || isMobile ? 'spacing24' : 'xxxl',
        }}
      >
        <Box fill>
          <InvestmentBannerTitle></InvestmentBannerTitle>
        </Box>
        {getWrapper(
          <Box
            direction="column"
            width={isMobile ? '100%' : undefined}
            margin={isMobile ? { top: 'spacing16' } : { left: 'auto' }}
          >
            {lastDateUpdate && (
              <Text color="textOnColor" margin={{ bottom: 's' }} style={{ opacity: 0.5 }}>
                {`${t('All figures based as of ')} ${lastDateUpdate?.format(DEFAULT_DATE_FORMAT)}`}
              </Text>
            )}

            <Box
              direction={isMobile && isPerformanceMode ? 'column' : 'row'}
              gap={isMobile ? 'spacing8' : 'spacing12'}
            >
              {children}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default InvestmentsBanner;
